module.exports = __webpack_public_path__ + "img/gen_metal1601.0f709617.png";